/* global module, require */
const entries = require('./objectEntries');

const applicators = {
	_tag: null,
	_parent: (el, parent) => {
		if (parent) parent.appendChild(el);
	},
	dataset: (el, data) => {
		entries(data || {}).forEach(e => {
			const [k, v] = e;
			el.dataset[k] = v;
		});
	},
};

module.exports = function createElement(attributes) {
	const attrs = attributes || {};

	var el = document.createElement(attrs._tag || 'div');
	entries(attrs).forEach(e => {
		const [k, v] = e;
		if (applicators[k]) applicators[k](el, v);
		else el[k] = v;
	});

	return el;
};
